import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import type { RootState } from "../store/store";
import { isTokenValid } from "../utils/isTokenValid";
import {
  COLABORADOR_LOGIN,
  COLABORADOR_PRIMEIRO_ACESSO,
} from "../views/colaborador/routes";

type Props = { children: React.ReactElement };

/**
 * Rotas do portal do colaborador CLT.
 *
 * Lê `employeeAuth.accessToken` — o MESMO nome que o slice grava. Ler um campo
 * com outro nome é o que quebrou a sessão de freelancer nos redirects (BUG-006).
 *
 * Enquanto `isFirstLogin` for verdadeiro, tudo leva à tela de primeiro acesso:
 * a senha provisória foi entregue em papel pelo DP e não pode continuar valendo
 * enquanto o colaborador usa o app.
 */
const EmployeeRoute: React.FC<Props> = ({ children }) => {
  const location = useLocation();

  const rehydrated = useSelector((s: RootState) => !!(s as any)._persist?.rehydrated);
  const token = useSelector((s: RootState) => s.employeeAuth?.accessToken);
  const isFirstLogin = useSelector((s: RootState) => s.employeeAuth?.isFirstLogin);

  if (!rehydrated) return null;

  if (!isTokenValid(token)) return <Navigate to={COLABORADOR_LOGIN()} replace />;

  if (isFirstLogin && location.pathname !== COLABORADOR_PRIMEIRO_ACESSO()) {
    return <Navigate to={COLABORADOR_PRIMEIRO_ACESSO()} replace />;
  }

  return children;
};

export default EmployeeRoute;
